/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SortItem
 */
export interface SortItem {
    /**
     * 数据编号
     * @type {number}
     * @memberof SortItem
     */
    id: number;
    /**
     * 排序值
     * @type {number}
     * @memberof SortItem
     */
    sort: number;
}

/**
 * Check if a given object implements the SortItem interface.
 */
export function instanceOfSortItem(value: object): value is SortItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    return true;
}

export function SortItemFromJSON(json: any): SortItem {
    return SortItemFromJSONTyped(json, false);
}

export function SortItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sort': json['sort'],
    };
}

export function SortItemToJSON(json: any): SortItem {
    return SortItemToJSONTyped(json, false);
}

export function SortItemToJSONTyped(value?: SortItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sort': value['sort'],
    };
}

